import React from "react";
import classes from "./Modal.module.css";
import sessionimg from "../Assests/Images/sessionimg.png";
import CommonButton from "../Components/Buttons/CommonButton";

interface props {
  handleSuccess: () => void;
}

function SessionExpiredModalDemo({ handleSuccess }: props) {
  return (
    <div>
      <div className={classes.sessionexpired_heading_bg}>
        <h4 style={{ margin: 0 }}>Session Expired</h4>
      </div>
      <div className={classes.modal_container}>
        <div style={{ display: "flex", alignItems: "baseline", gap: "10px" }}>
          <img src={sessionimg} alt="sessionimg" style={{ width: 40 }} />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "11px",
              alignSelf: "center",
            }}
          >
            <p style={{ margin: 0, fontSize: 16, marginTop: 10 }}>
              Your session has expired
            </p>
            <p style={{ margin: 0, fontSize: 16 }}>
              You will be redirected to the Login page.
            </p>
          </div>
        </div>
        <div
          className={classes.modal_button_container}
          style={{ justifyContent: "end" }}
        >
          <CommonButton
            onClick={() => handleSuccess()}
            type="button"
            name="OK"
            style={{ maxWidth: 80 }}
            classname="submit_btn"
          />
        </div>
      </div>
    </div>
  );
}

export default SessionExpiredModalDemo;
